import { createFileRoute } from '@tanstack/react-router'
import { MyTasks } from '@/components/MyTasks'

export const Route = createFileRoute('/_auth/task/')({
  component: MyTasksRoute,
})

function MyTasksRoute() {
  return <MyTasks />
}
